import { render, staticRenderFns } from "./MarketplaceDescription.vue?vue&type=template&id=235651da&"
import script from "./MarketplaceDescription.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDescription.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceDescription.vue?vue&type=style&index=0&id=235651da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports